<footer>
  <script>
    export default {
      state: {
        version: typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'unknown',
        commitSha: typeof __GIT_COMMIT_SHA__ !== 'undefined' ? __GIT_COMMIT_SHA__ : 'unknown'
      }
    }
  </script>
  <footer class="w-100 mt-auto py-3 border-top bg-light">
    <div class="container">
      <div class="row">
        <div class="col-md-6 d-flex align-items-center">
          <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
            <img src="/assets/discomon.png" alt="Discomon Logo" height="24">
            Opener by FlyIoT
          </a>
          <span class="text-muted">&copy; 2023-2025, All rights reserved.</span>
        </div>
        <div class="col-md-6">
          <div class="d-flex justify-content-end align-items-center">
            <span class="text-muted">
              <small>v{state.version} ({state.commitSha})</small>
            </span>
          </div>
        </div>
      </div>
    </div>
  </footer>
</footer>
